@if (!showSuccessInfo() && !showEmailNotFoundInfo()) {
  <div class="forgot-password-instructions">
    <p>Enter your email address and click Submit. We will send you an email that includes a link to {{ isActive() ? "create" : "reset" }} your password.</p>
  </div>

  <div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" (keydown.enter)="onSubmit()" autocomplete="off" novalidate>
      <div class="form-fields">
        <!-- New Password Field -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email" required data-lpignore="true" autocomplete="email" />
        </mat-form-field>

        <!-- Submit Button -->
        <div class="submit-btn-wrapper forgot-btn">
          <!-- Create User -->
          <button mat-flat-button type="submit" [disabled]="form.invalid || saveState()">Submit</button>
        </div>
      </div>
    </form>
  </div>

  @if (apiErrorMessage()) {
    <div class="alert-danger" style="margin-top: 24px">
      Error, Please check your E-mail and try again.
      {{ apiErrorMessage() }}
    </div>
  }
} @else if (showSuccessInfo()) {
  @if (isActive()) {
    <div>
      Your request has been successfully sent to {{ form.get("email")?.value }}. If you don't receive any emails within 5 minutes, please check your spam folder or contact the IT department of your organisation to release your activation email from
      the quarantine.
    </div>
  } @else {
    <div>We just sent a message to {{ form.get("email")?.value }} with a link to reset your password. Please check your Mailbox.</div>
  }
  <button mat-raised-button type="button" style="margin-top: 24px" (click)="routeToLogin()">Back to Login</button>
}

@if (showEmailNotFoundInfo()) {
  <div class="dnnFormMessage dnnFormError">The email provided is not registered in our records. Please <a href="/customer-area/create-account">register a new account</a>.</div>
  <div style="margin-top: 24px">
    <button type="button" class="btn" style="margin-right: 4px" (click)="showEmailNotFoundInfo.set(false)">Cancel</button>
    <a class="btn btn-primary" href="/customer-area/create-account">Register</a>
  </div>
}
